//Generated File 
export default class DomainBaseEntities{
	static readonly AnalysisSet = `AnalysisSet`;
	static readonly ApprovalDefinition = `ApprovalDefinition`;
	static readonly Branch = `Branch`;
	static readonly ConfigEntry = `ConfigEntry`;
	static readonly Department = `Department`;
	static readonly DocCategory = `DocCategory`;
	static readonly DocumentBook = `DocumentBook`;
	static readonly DocumentTerm = `DocumentTerm`;
	static readonly Employee = `Employee`;
	static readonly LegalEntity = `LegalEntity`;
	static readonly MasterGroup = `MasterGroup`;
	static readonly ReportDefinition = `ReportDefinition`;
	static readonly Sector = `Sector`;
	static readonly User = `User`;
}
